/**
 * Imports for the Autodesk.Viewing.Scene namespace
 */

/**
 * When exporting a THREE type here, make sure adequate JSDoc comments for the public
 * documentation exist both in three-slim.js and related three-backports.js.
 * @note v7 uses three.js for APS, three-slim.js for fluent. v8 is planned to use three-slim.js exclusively.
 */

export { Node3D } from "../wgs/scene/scene-graph/Node3D";
export { MeshNode3D } from "../wgs/scene/scene-graph/MeshNode3D";

export { VisibilityState } from "../wgs/scene/MeshCollectionBase";

export { LeanBufferGeometry as BufferGeometry } from "../wgs/scene/BufferGeometry";
export { BufferAttribute } from "three";